const o=["ES","FR"];export{o as ALLOWED_COUNTRIES};
